import React, { useEffect, useState } from 'react';
import Session from 'supertokens-web-js/recipe/session';
import { useTenantNavigation } from '@/hooks/navigation/useTenantNavigation';
import TriEventsLoadingScreen from '@/components/common/TriEventsLoadingScreen';

const AlreadyLoggedIn: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasSession, setHasSession] = useState(false);
  const { navigateWithTenant } = useTenantNavigation();

  useEffect(() => {
    const checkSession = async () => {
      try {
        const exists = await Session.doesSessionExist();
        setHasSession(exists);
      } catch (err) {
        setHasSession(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkSession();
  }, []);

  if (isLoading) {
    return <TriEventsLoadingScreen loading={true} />;
  }

  if (hasSession) {
    navigateWithTenant('/dashboard');
    return <TriEventsLoadingScreen loading={true} />;
  }

  return <>{children}</>; // Keep fragment for children
};

export default AlreadyLoggedIn;